import type { IconName } from '../components/ui/Icon';

/**
 * Bottom navigation config. Adding a tab (e.g. "Inbox" for DMs or "Live")
 * is a one-line change here plus a route in routes.tsx.
 */
export interface NavTab {
  id: string;
  label: string;
  icon: IconName;
  /** Path the tab opens. */
  path: string;
  /** Route prefixes that keep the tab highlighted. */
  match: string[];
  primary?: boolean;
  requiresAuth?: boolean;
}

export const NAV_TABS: NavTab[] = [
  { id: 'home', label: 'Home', icon: 'home', path: '/', match: ['/', '/v/'] },
  { id: 'discover', label: 'Ontdekken', icon: 'discover', path: '/discover', match: ['/discover', '/search', '/tag/'] },
  { id: 'create', label: 'Create', icon: 'plus', path: '/create', match: ['/create'], primary: true, requiresAuth: true },
  { id: 'music', label: 'Muziek', icon: 'music', path: '/music', match: ['/music', '/sound/', '/artist/', '/album/', '/playlist/', '/library'] },
  { id: 'profile', label: 'Profiel', icon: 'user', path: '/me', match: ['/me', '/u/', '/settings', '/notifications'], requiresAuth: true },
];

export function activeTab(pathname: string): string | null {
  const exact = NAV_TABS.find((t) => t.match.includes(pathname));
  if (exact) return exact.id;
  return NAV_TABS.find((t) => t.match.some((m) => m !== '/' && pathname.startsWith(m)))?.id ?? null;
}
